import tinymce from "tinymce";
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/models/dom";

import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/code";

export function initTinyMCE() {
  document.addEventListener("DOMContentLoaded", () => {
    const textarea = document.querySelector("textarea.tinymce");
    if (!textarea) return;

    tinymce.init({
      license_key: 'gpl',
      selector: "textarea.tinymce",
      skin_url: "/assets/tinymce/skins/ui/oxide",
      content_css: "/assets/tinymce/skins/content/default/content.css",
      plugins: "link image media table code",
      toolbar: "undo redo | styleselect | bold italic | alignleft aligncenter alignright | link image media | tableaubutton | code",
      height: 400,

      automatic_uploads: true,

      images_upload_handler: function (blobInfo, progress) {
        return new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append("file", blobInfo.blob(), blobInfo.filename());

          fetch("/upload_image", {
            method: "POST",
            headers: {
              "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
            },
            body: formData
          })
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.json();
            })
            .then(json => {
              if (json?.location && typeof json.location === "string") {
                resolve(json.location);
              } else {
                throw new Error("Invalid response JSON: missing `location` key");
              }
            })
            .catch(error => {
              console.error("[TinyMCE Upload Error]", error);
              reject("Image upload failed");
            });
        });
      },

      extended_valid_elements: 'button[class|style|data-url|data-name],div[class|id|style],script[src|type],a[href|data-mce-fragment],img[src|style|alt|width|height|data-mce-fragment],noscript,param[name|value],object[class|width|height|style]',

      setup: function (editor) {
        editor.ui.registry.addButton("tableaubutton", {
          text: "Insert Tableau Button",
          icon: "embed",
          onAction: function () {
            editor.windowManager.open({
              title: "Insert Tableau Modal Button",
              body: {
                type: "panel",
                items: [
                  { type: "input", name: "url", label: "Tableau Public URL" },
                  { type: "input", name: "name", label: "Button Text" },
                  { type: "input", name: "dataname", label: "Data-Name Attribute (optional)" }
                ]
              },
              buttons: [
                { type: "cancel", text: "Cancel" },
                { type: "submit", text: "Insert", primary: true }
              ],
              onSubmit: function (api) {
                const data = api.getData();
                const url = data.url?.trim();
                const label = data.name?.trim() || "Open Tableau";
                const dataname = data.dataname?.trim() || "Tableau Modal";

                if (url) {
                  editor.insertContent(`
                    <button class="btn btn-primary open-tableau-popup"
                            data-url="${url}"
                            data-name="${dataname}"
                            style="background-color:#4472c4; border-color:#4472c4;">
                      ${label}
                    </button>
                  `);
                  api.close();
                }
              }
            });
          }
        });
      }
    });
  });
}